/**--external-- */
import React from "react";

/**--internal-- */
import { FormTextAreaInput } from "UIComponents/TextAreaInput";
import Textview from "UIComponents/Textview";

/**--relative-- */
import Field from "../Field";

class FieldMultiLineInput extends Field {
  renderPreviewContent = () => {
    const { data, placeholder } = this.props;
    return (
      <FormTextAreaInput mode="edit" placeholder={placeholder} value={data} />
    );
  };

  renderEdit = () => {
    const {
      updateInputField,
      value,
      name,
      onBlurInputField,
      onFocusInputField,
      customRef,
      readOnly,
      isRequired,
      placeholder,
    } = this.props;

    return (
      <FormTextAreaInput
        mode="edit"
        placeholder={placeholder}
        onBlurInputField={onBlurInputField}
        onFocusInputField={onFocusInputField}
        value={value}
        updateInputField={updateInputField}
        name={name}
        customRef={customRef}
        readOnly={readOnly}
        isRequired={isRequired}
      />
    );
  };

  renderView = () => {
    const {
      customRef,
      name,
      value,
      textStyle,
      applyDefaultClass,
      customTextStyle,
      emptyText,
    } = this.props;

    return (
      <Textview
        customRef={customRef}
        name={name}
        value={value}
        mode="view"
        textStyle={textStyle}
        applyDefaultClass={applyDefaultClass}
        customTextStyle={customTextStyle}
        emptyText={emptyText}
      />
    );
  };
}

export default FieldMultiLineInput;
FieldMultiLineInput.displayName = "FieldMultiLineInput";
